import { render, staticRenderFns } from "./MobileFooterActions.vue?vue&type=template&id=485f5783"
import script from "./MobileFooterActions.vue?vue&type=script&lang=js"
export * from "./MobileFooterActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports